<div class="pie-chart" *ngIf="data">
  <canvas #chartEl></canvas>
</div>
